<template>
  <div class="info main_center">
    <div class="top-content busWinessLeft">
      <div class="left-navbar">
        <el-button @click="back()" size="small">返回</el-button>
      </div>
    </div>
    <div class="right-content clearfix busWinessRight" style="top: 60px">
      <el-card class="box-card">
        <el-form :model="form" label-width="220px" ref="form"
          style="position: relative; margin-bottom: 24px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="文件标题：" size="small" prop="title">
                {{form.title}}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="内容：" prop="content" size="small">
                <div v-html="form.content"></div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="发布栏目：" prop="publishColumn" size="small">
                {{form.publishColumnName}}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="发布人：" size="small" prop="publishUser">
                {{form.publishUser}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :key="index" :span="24" v-for="(item, index) in form.fileList">
              <el-form-item :label="item.fileTypeName ? (item.fileTypeName + '：') : '附件：'"
                            :prop="'attachments' + item.fileType" size="small">
                <affix-msg :showDetail="true" :docItem.sync="item" :docName.sync="item.name" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import affixMsg from "@/components/affixMsg";
import {saveInfomationPublishData, getInfomationPublishDetail, submitInfomationPublishData,} from "@/server/mainCredit.js";
import { mapState } from "vuex";
export default {
  components: {
    affixMsg,
  },
  data() {
    return {
      form: {
        id: "",
        title: "",
        content: "",
        attachments: [],
        publishColumn:'',
        publishUser:'',
        fileList: [],
        publishFlag:"",
      },
    };
  },

  created() {
    this.$store.dispatch("dataDictionary/getInfomationPublishAtt");
    this.$store.dispatch("dataDictionary/getPublishColumnOption");
  },

  computed: {
    ...mapState({
      infomationPublishAtt: (state) => {
        return state.dataDictionary.infomationPublishAtt;
      },
      publishColumnOption: (state) => {
        return state.dataDictionary.publishColumnOption;
      },
    }),
  },

  watch: {
    infomationPublishAtt: {
      immediate: true,
      deep: true, // 深度监听
      handler(val, newVal) {
        this.$nextTick(() => {
          if (this.$route.query.id) return;
          // 初始化附件数据
          let attachments = JSON.parse(
            JSON.stringify(this.infomationPublishAtt)
          );
          this.form.attachments = attachments;
        });
      },
    },
  },

  mounted() {
    if (this.$route.query.id) {
      this.form.id = this.$route.query.id;
      getInfomationPublishDetail(this.$route.query.id).then((res) => {
        if (res.data.code == 1) {
          this.form = { ...this.form, ...res.data.data };
          this.getAttachmentsData();
        }
      });
    }
  },

  methods: {
    getAttachmentsData() {
      this.$httpReq.get(`/attachment/getDataByCodeAndEid?categoryCode=portal_information_release_att&entityId=${this.$route.query.id}`)
        .then(({ data }) => {
          if (data.code == 1) {
            this.form.attachments = data.data;
            for (let i = 0; i < data.data[0].attFiles.length; i += 1) {
              this.fileChange(
                {
                  ...data.data[0],
                  ...data.data[0].attFiles[i],
                },
                "add"
              );
            }
          }
        });
    },

    back() {
      tabsCloseCurrentHandle();
      this.$router.push({
        name: "infomationPublishList",
        query: {},
      });
    },

    fileChange(files, flag) {
      if (flag == "add") {
        this.form.fileList.push({
          hideLable: true,
          ...files,
          sysAttachmentDataId: (this.infomationPublishAtt[0] || {}).id,
        });
      } else if (flag == "del") {
        let dataList = this.form.fileList;
        if (files.id) {
          this.deleteFile(files.id);
        }
        let result = dataList.filter((item) => {
          if (item.uid && files.uid) {
            return item.uid != files.uid;
          }
          if (item.id && files.id) {
            return item.id != files.id;
          }
          return true;
        });
        this.form.fileList = result;
      }
    },

    deleteFile(id) {
      this.$httpReq({
        method: "post",
        url: `/attachment/delattachmentbyid`,
        params: {
          id: id,
        },
      }).then((res) => {
        if (res.data.code == 1) {
          this.$message.success("删除成功");
        }
      });
    },
  },
};
</script>
<style>
.w-e-toolbar {
  z-index: 101 !important;
}

.w-e-text-container {
  z-index: 100 !important;
}
</style>
